const SOCKET_CONFIG = {
	server: process.env.REACT_APP_HAMMURABI_API,
};

export default SOCKET_CONFIG;
